module.exports = __webpack_public_path__ + "static/media/rank-s.d3532433.png";